module.exports = __webpack_public_path__ + "img/person_fill.f43007bf.svg";